// Pure payload rules for updating an existing outbound trunk. Separated from the
// sheet so the detach semantics are unit-testable.

export interface OutboundAuthRefs {
  ipacl_uuid?: string | null
  credential_uuid?: string | null
}

/**
 * Empty-string patch for auth the trunk HAD and no longer has.
 *
 * The update is a POST and axios drops undefined keys from the body, so an ACL
 * or credential the user just unchecked (or that switching the platform to
 * LiveKit removed) would stay attached server-side while the form shows it
 * gone. Empty string is the detach signal the pre-redesign selects already sent.
 *
 * Deliberately NOT widened to a trunk that never had the value: an untouched
 * trunk keeps exactly today's payload, so this cannot introduce a new rejection
 * on a field the account has never sent.
 */
export const buildOutboundDetachPatch = (
  stored: OutboundAuthRefs | undefined | null,
  next: OutboundAuthRefs,
): { ipacl_uuid?: string; credential_uuid?: string } => {
  const patch: { ipacl_uuid?: string; credential_uuid?: string } = {}
  if (stored?.ipacl_uuid && !next.ipacl_uuid) patch.ipacl_uuid = ''
  if (stored?.credential_uuid && !next.credential_uuid) patch.credential_uuid = ''
  return patch
}
